// third-party
import { merge } from "lodash";

// ==============================|| OVERRIDES - MAIN ||============================== //

export default function ComponentsOverrides(theme) {
  return merge();
  // Button(theme),
}
